

import { utils } from 'apprise-core/utils'
import { useRenderGuard } from 'apprise-frontend-core/utils/renderguard'
import { PropsWithChildren } from 'react'
import { useCategoryStore } from './category/store'
import { useTagStore } from './tag/store'



export const TagLoader = (props: PropsWithChildren) => {


    const { children } = props

    const catStore = useCategoryStore()
    const store = useTagStore()

    // loads tags and categories, optionally after installing mocks.
    const activate = async () => await utils().waitOn(store.fetchAllTags(), catStore.fetchAllCategories())



    // activates before rendering children.
    const { content } = useRenderGuard({

        render: children,

        orRun: activate,

    })

    return content
}